export function limpa_mascara_cpf_cnpj(cpf_cnpj: string){
    return cpf_cnpj.replaceAll(".","").replaceAll("-","").replaceAll("/","").replaceAll(" ","")
}

export function mascaraCPF(value:string){
    return value
      .replace(/\D/g, '') // substitui qualquer caracter que nao seja numero por nada
      .replace(/(\d{3})(\d)/, '$1.$2') // captura 2 grupos de numero o primeiro de 3 e o segundo de 1, apos capturar o primeiro grupo ele adiciona um ponto antes do segundo grupo de numero
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d{1,2})/, '$1-$2')
      
  }